import React from 'react';
import { observer } from 'mobx-react';

import { useEpgContext } from 'context/epgContext/epgContext';

import Channels from './components/Channels/Channels';
import GridMovementHooks from './components/GridMovementHooks/GridMovementHooks';
import Programs from './components/Programs/Programs';
import { useGridHooksCombiner } from './hooks/useGridHooksCombiner/useGridHooksCombiner';

import styles from './Grid.module.scss';

function Grid() {
  const { epgRef } = useEpgContext();
  const { onDragStart, onDragEnd, onDragMove } = useGridHooksCombiner();

  return (
    <div
      ref={epgRef}
      role='presentation'
      tabIndex={-1}
      className={styles.wrapper}
      onMouseDown={onDragStart}
      onMouseUp={onDragEnd}
      onMouseMove={onDragMove}
      onMouseLeave={onDragEnd}
      onMouseUpCapture={onDragEnd}
    >
      <Channels />
      <GridMovementHooks />
      <Programs />
    </div>
  );
}

export default observer(Grid);
